export const COMPLETE_ID_VALIDATION = 'completeIdentityValidation';
export const GET_SRC_PROFILE = 'getSrcProfile';
export const IDENTITY_LOOKUP = 'identityLookUp';
export const INITIATE_ID_VALIDATION = 'initiateIdentityValidation';
export const IS_RECOGNIZED = 'isRecognized';
export const UNIQUE_ID_TOKEN = 'uniqueIdTokens';
